import React, { useEffect } from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import cutStrAtAndAddDots from "utils/cutStrAtAndAddDots";
import useTableOptions from "Hooks/useTableOptions";
import {
  getParseStatusLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import CommonChip from "Components/UI/Tables/CommonChip";
import { useEndCustomers } from "Context/EndCustomers";

const createTableRows = (endcustomers) => {
  return endcustomers.map((c) => {
    return [
      c.Id,
      c.Title,
      c.ClientId,
      c.ClientTitle,
      c.OrgNo,
      c.Name,
      getParseStatusLabelById(c.ParseStatus),
      cutStrAtAndAddDots(c.ParseMessage, 45),
      getSystemStatusLabelById(c.SystemStatus),
      c.CreateTime,
    ];
  });
};

export default function EndCustomersTable() {
  const { endCustomers, fetchEndCustomers } = useEndCustomers();
  const { handleColumnShow, isColDisplayed } = useTableOptions(
    "EndcustomersMainTable"
  );

  useEffect(() => {
    fetchEndCustomers();
  }, []);

  if (!endCustomers) {
    return null;
  }
  const rows = createTableRows(endCustomers);
  const columns = [
    {
      name: "",
      options: {
        filter: false,
        // sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
        display: isColDisplayed("ID"),
      },
    },
    {
      name: "Titel",
      options: {
        filter: false,
        display: isColDisplayed("Titel"),
      },
    },
    {
      name: "Klient ID",
      options: {
        filter: true,
        display: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/clients/${rows[dataIndex][2]}`}>
              {rows[dataIndex][2]}
            </Link>
          );
        },
      },
    },
    {
      name: "Klient",
      options: {
        // filter: false,
        display: isColDisplayed("Slutkunds ID"),
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {rows[dataIndex][2] === null ? (
                ""
              ) : (
                <Link to={`/clients/${rows[dataIndex][2]}`}>
                  {rows[dataIndex][3]}
                </Link>
              )}
            </>
          );
        },
      },
    },
    {
      name: "Org.nr",
      options: {
        // filter: false,
        display: isColDisplayed("org.NR"),
      },
    },
    {
      name: "Namn",
      options: {
        filter: true,
        display: isColDisplayed("Namn"),
      },
    },
    {
      name: "Kontrollstatus",
      options: {
        filter: true,
        display: isColDisplayed("Kontrollstatus"),
        // sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Kontrollmeddelande",
      options: {
        filter: false,
        display: isColDisplayed("Kontrollmeddelande"),
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        display: isColDisplayed("Status"),
        // sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
        display: isColDisplayed("Skapad"),
      },
    },
  ];

  const options = {
    selectableRowsHeader: false,
    onViewColumnsChange: (changedColumn, action) => {
      handleColumnShow(changedColumn, action);
    },
    selectableRowsHideCheckboxes: true,
    filterType: "dropdown",
    responsive: "standard",
    downloadOptions: {
      separator: ";",
      filename: "all_clients.csv",
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
